<template>
  <div>
    <Loading ref="loading"></Loading>
    <Drawer :open="isOpen" title="选择游戏">
      <div class="game-list">
        <div class="game" v-for="game in gameList" :key="game.papp_id">
          <div class="info">
            <img :src="game.icon" />
            <div class="name">{{ game.papp_name }}</div>
          </div>
          <Button
            :variant="game.papp_id === current ? 'plain' : 'fill'"
            height="2.2rem"
            width="6rem"
            border-radius="0.5rem"
            class="select-btn"
            @click="handleSelectGame(game)"
          >
            {{ game.papp_id === current ? "当前游戏" : "选择" }}
          </Button>
        </div>
      </div>
    </Drawer>
    <Dialog
      @close="showConfirm = false"
      class="confirm"
      :open="showConfirm"
      show-close
      title="提示"
      width="70%"
      close-on-click-modal
    >
      <div class="info">
        选择游戏【末世王者】，填写并提交角色信息后，将不能更换其他游戏和游戏角色
      </div>
      <div class="btns">
        <Button
          @click="handleSelectGame(confirmGame, true)"
          class="confirm"
          width="8rem"
          >确认</Button
        >
        <Button @click="showConfirm = false" class="cancel" width="8rem"
          >取消</Button
        >
      </div>
    </Dialog>
  </div>
</template>

<script>
import Button from "@/components/button/index.vue";
import Drawer from "@/components/drawer/index.vue";
import Dialog from "@/components/dialog/index.vue";
import Loading from "@/components/loading/index.vue";
export default {
  emits: ["select"],
  components: {
    Drawer,
    Button,
    Dialog,
    Loading,
  },
  data() {
    return {
      confirmGame: null,
      isOpen: false,
      gameList: [],
      showConfirm: false,
    };
  },
  props: {
    current: {
      type: Number,
    },
  },
  methods: {
    loadGameList({ app_type }) {
      this.$refs.loading.show("正在获取游戏列表...");
      const params = {
        tm: Date.now(),
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
        app_type,
      };
      params.sign = this.$RSSign(params, this.$xh.xhParams.key);
      this.$ajax({
        method: "get",
        url: this.$api.v2.gameList,
        params,
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.gameList = res.data.data;
          } else {
            this.$toast(res.data.msg);
          }
        })
        .catch((err) => {
          this.$toast("网络异常，请刷新重试");
          console.log(err);
        })
        .finally(() => {
          this.$refs.loading.hide();
        });
    },
    open(game) {
      this.isOpen = true;
      this.loadGameList(game);
    },
    handleSelectGame(game, isConfirm) {
      if (game.papp_id === 338 && !isConfirm) {
        this.confirmGame = game;
        this.showConfirm = true;
        return;
      }
      this.showConfirm = false;
      this.$emit("select", game);
      this.isOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.game-list {
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  .game {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    .info {
      display: flex;
      align-items: center;
      img {
        width: 4rem;
        height: 4rem;
        border-radius: 0.5rem;
      }
      .name {
        font-size: 1.2rem;
        margin-left: 1rem;
      }
    }
    .select-btn {
      border-radius: 0.4rem;
      flex-shrink: 0;
      font-size: 1.2rem;
      border-width: 0.12rem;
    }
  }
}

.confirm {
  z-index: 10000;
  :deep(.outer) {
    .dialog {
      .header {
        height: 3rem;
        .dialog-close {
          top: -0.1rem;
          width: 0.9rem;
        }
      }
      .body {
        padding: 0.5rem 0 1rem 0;
      }
    }
  }
  .info {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    text-align: center;
    font-weight: 600;
    letter-spacing: 0.05rem;
  }
  .btns {
    display: flex;
    justify-content: center;
    margin-top: 0.5rem;
    gap: 1rem;
    .cancel {
      background: rgb(195, 195, 195);
    }
  }
}
</style>
